module.exports = __webpack_public_path__ + "img/about_mp.891bc04e.png";